export default __webpack_public_path__ + "img/icon-menu.d6a42c27.svg";